module.exports = __webpack_public_path__ + "static/media/15.6b070279.jpg";